export const cuisineList = [
  { key: "0", name: "Select Cuisine" },
  { key: "10632", name: "African" },
  { key: "9908", name: "American" },
  { key: "10659", name: "Asian" },
  { key: "10640", name: "Bar" },
  { key: "10642", name: "Cafe" },
  { key: "5379", name: "Chinese" },
  { key: "10669", name: "Contemporary" },
  { key: "10666", name: "Deli" },
  { key: "10654", name: "European" },
  { key: "10346", name: "Indian" },
  { key: "4617", name: "Italian" },
  { key: "10648", name: "International" },
  { key: "5473", name: "Japanese" },
  { key: "10649", name: "Mediterranean" },
  { key: "10633", name: "Moroccan" },
  { key: "10641", name: "Pizza" },
  { key: "10670", name: "Pub" },
  { key: "10643", name: "Seafood" },
  { key: "10345", name: "Steakhouse" },
  { key: "10653", name: "Sushi" },
  { key: "10660", name: "Thai" },
  { key: "10675", name: "Vietnamese" },
  
];
